import { Send, MailOpen, MousePointerClick, Radio } from "lucide-react";
import StatCard from "../../../components/ui/StatCard";
import { CAMPAIGN_KPIS } from "./campaign.data";

const ICONS = {
  sent:   { icon: Send,              iconBg: "var(--color-primary-tint)", iconColor: "var(--color-primary)" },
  open:   { icon: MailOpen,          iconBg: "var(--color-success-bg)",   iconColor: "var(--color-success)" },
  click:  { icon: MousePointerClick, iconBg: "var(--color-info-bg)",      iconColor: "var(--color-info)" },
  active: { icon: Radio,             iconBg: "var(--color-secondary-tint)", iconColor: "var(--color-secondary)" },
};

export default function CampaignStats() {
  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-4">
      {CAMPAIGN_KPIS.map((k) => (
        <StatCard key={k.key} {...k} {...ICONS[k.key]} />
      ))}
    </div>
  );
}
